import { createFileRoute } from "@tanstack/react-router";
import { InventoryChoicePage } from "@/components/inventory/ChoicePage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/inventory_/new")({
  beforeLoad: () => {
    requireAuth();
  },
  component: InventoryChoicePage,
});
